(function () {
  var CENTS_ATTRS = ['data-oprice', 'data-ocprice', 'data-original-vprice', 'data-original-compare-vprice'];
  var MONEY_ATTRS = ['variant_price', 'variant_price-compare', 'data-vprice', 'data-compare-vprice'];
  var MIXED_ATTRS = ['data-price', 'data-cprice'];
  var COMPARE_ATTRS = new Set([
    'data-ocprice',
    'data-cprice',
    'variant_price-compare',
    'data-original-compare-vprice',
    'data-compare-vprice',
  ]);
  var PRICE_ATTRS = CENTS_ATTRS.concat(MONEY_ATTRS, MIXED_ATTRS);
  var PRICE_ATTR_SELECTOR = PRICE_ATTRS.map(function (name) {
    return '[' + name + ']';
  }).join(',');
  var BUNDLE_SELECTOR = '.product_bundle_selector, .main_product_variant, .product-single__variants';
  var UPSELL_CARD_SELECTOR = '.pdp_upsell_card, .cart_upsell_card';
  var PDP_PRICE_SELECTOR = ['.product-information', 'sticky-add-to-cart']
    .flatMap(function (scope) {
      return [scope + ' .price', scope + ' .compare-at-price'];
    })
    .join(', ');
  var NOT_PDP_PRICE_SELECTOR = [BUNDLE_SELECTOR, UPSELL_CARD_SELECTOR, 'product-card', '.resource-card'].join(', ');
  var BUILDER_CARD_SELECTOR = '.multi-step-bundle-builder-section .product-info';
  var MONEY_IN_TEXT = /\$\s?[\d,]+(?:\.\d{2})?/;

  function toCents(amount) {
    return Math.round(Number(amount) * 100);
  }

  function formatMoney(ABConvert, price, amount) {
    var shopify = window.Shopify;
    if (shopify && typeof shopify.formatMoney === 'function') {
      try {
        return shopify.formatMoney(toCents(amount));
      } catch {
        return ABConvert.formatPrice(amount, price.currency);
      }
    }
    return ABConvert.formatPrice(amount, price.currency);
  }

  function variantIdOf(el) {
    var dataId = el instanceof HTMLElement ? el.dataset.variantId : undefined;
    if (dataId) return dataId;
    return el instanceof HTMLOptionElement ? el.value : null;
  }

  function nextValue(ABConvert, price, name, current) {
    var amount = COMPARE_ATTRS.has(name) ? price.compareAtAmount : price.amount;
    if (amount === null || amount === undefined) return null;
    var inCents = CENTS_ATTRS.includes(name) || (MIXED_ATTRS.includes(name) && /^\d+$/.test(current.trim()));
    return inCents ? String(toCents(amount)) : formatMoney(ABConvert, price, amount);
  }

  function applyToPriceAttributes(ABConvert, getPrice) {
    var bundleChanged = false;
    document.querySelectorAll(PRICE_ATTR_SELECTOR).forEach(function (el) {
      var variantId = variantIdOf(el);
      if (!variantId) return;
      var price = getPrice(variantId);
      if (!price) return;

      PRICE_ATTRS.forEach(function (name) {
        var current = el.getAttribute(name);
        if (current === null) return;
        var next = nextValue(ABConvert, price, name, current);
        if (next === null || next === current) return;
        el.setAttribute(name, next);
        if (el.closest(BUNDLE_SELECTOR)) bundleChanged = true;
      });
    });
    return bundleChanged;
  }

  function setText(el, text) {
    if (el && (el.textContent ?? '').trim() !== text) el.textContent = text;
  }

  function applyToUpsellCards(ABConvert, getPrice) {
    document.querySelectorAll(UPSELL_CARD_SELECTOR).forEach(function (card) {
      var idField = card.querySelector('[name="id"]');
      var price = idField?.value ? getPrice(idField.value) : null;
      var amount = price?.amount;
      if (!price || amount === null || amount === undefined) return;
      setText(card.querySelector('.upsell-original--price'), formatMoney(ABConvert, price, amount));
      if (price.compareAtAmount !== null && price.compareAtAmount !== undefined) {
        setText(card.querySelector('.upsell-compare--price'), formatMoney(ABConvert, price, price.compareAtAmount));
      }
    });
  }

  // The card price and "Add - $24.99" button are Liquid-only; the builder tracks the card's variant on .quantity-value.
  function applyToBuilderCards(ABConvert, getPrice) {
    document.querySelectorAll(BUILDER_CARD_SELECTOR).forEach(function (card) {
      var variantId = card.querySelector('.quantity-value[data-variant-id]')?.getAttribute('data-variant-id');
      var price = variantId ? getPrice(variantId) : null;
      var amount = price?.amount;
      if (!price || amount === null || amount === undefined) return;
      var formatted = formatMoney(ABConvert, price, amount);
      var button = card.querySelector('.addto-pack-btn');
      var buttonText = (button?.textContent ?? '').trim();
      if (button && MONEY_IN_TEXT.test(buttonText)) setText(button, buttonText.replace(MONEY_IN_TEXT, formatted));
      setText(card.querySelector('.product-price .price'), formatted);
      if (price.compareAtAmount !== null && price.compareAtAmount !== undefined) {
        setText(
          card.querySelector('.product-price .caompare-at-price'),
          formatMoney(ABConvert, price, price.compareAtAmount),
        );
      }
    });
  }

  function selectedVariantId() {
    var fromUrl = new URLSearchParams(location.search).get('variant');
    return fromUrl || String(window.shopifySelectedOrFirstAvailableVariantId ?? '');
  }

  // Horizon re-renders these on every variant change and ABConvert only restores the compare-at price.
  function applyToProductPrice(ABConvert, getPrice) {
    var variantId = selectedVariantId();
    var price = variantId ? getPrice(variantId) : null;
    if (!price) return;
    document.querySelectorAll(PDP_PRICE_SELECTOR).forEach(function (el) {
      if (el.closest(NOT_PDP_PRICE_SELECTOR) || (el.textContent ?? '').includes(' - ')) return;
      var amount = el.classList.contains('compare-at-price') ? price.compareAtAmount : price.amount;
      if (amount !== null && amount !== undefined) setText(el, formatMoney(ABConvert, price, amount));
    });
  }

  function refreshBundleSelector() {
    if (typeof window.bundlePriceTotal === 'function') window.bundlePriceTotal();
    var coverSelect = document.querySelector(
      '.product_bundle_selector .bsc_strap_size_select .bsc_select_variant, ' +
        '.product_bundle_selector .strap_product_cover .bsc_select_variant',
    );
    if (coverSelect && typeof window.strapAccessoriesSet === 'function') window.strapAccessoriesSet(coverSelect);
  }

  function start(ABConvert) {
    if (typeof ABConvert.getPriceByVariantId !== 'function') return;
    if (!ABConvert.getAssignments?.().length) return;
    var getPrice = ABConvert.getPriceByVariantId.bind(ABConvert);

    function run() {
      if (applyToPriceAttributes(ABConvert, getPrice)) refreshBundleSelector();
      applyToUpsellCards(ABConvert, getPrice);
      applyToBuilderCards(ABConvert, getPrice);
      applyToProductPrice(ABConvert, getPrice);
    }

    run();
    new MutationObserver(run).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: PRICE_ATTRS,
    });
  }

  window.ABConvertQueue = window.ABConvertQueue || [];
  window.ABConvertQueue.push(start);
})();
